export enum WorkplaceMembersView {
	MEMBERS = 'MEMBERS',
	SETTINGS = 'SETTINGS',
	ACTIONS = 'ACTIONS',
}
